import type { WfxSessionData, WfxValidateGuidResponse } from './types';

const VALIDATE_GUID_PATH = '/WFXDotNetCoreAPI/WFXWebAIAPI/api/WFXAI/ValidateGUID';

export async function validateGuid(guid: string): Promise<WfxSessionData | null> {
  const base = (typeof WFX_API_BASE_URL === 'string' ? WFX_API_BASE_URL : '').replace(/\/$/, '');
  if (!base || !guid) return null;

  try {
    const resp = await fetch(`${base}${VALIDATE_GUID_PATH}?GUID=${encodeURIComponent(guid)}`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });
    if (!resp.ok) return null;

    const body = (await resp.json()) as WfxValidateGuidResponse;
    const ok =
      body?.status === 'Success' &&
      body?.statusCode === 200 &&
      Array.isArray(body?.responseData) &&
      body.responseData.length > 0;

    return ok ? body.responseData![0] : null;
  } catch {
    return null;
  }
}
